import type { Reputation } from "../profile/types";

const FINE_PRINT_LIST = new Intl.ListFormat("en", { type: "conjunction" });

export function ReputationThemesSection({
    reputation,
    storiesBelow = false,
}: {
    reputation: Reputation;
    storiesBelow?: boolean;
}) {
    const { positives, negatives } = reputation.themes;
    if (positives.length === 0 && negatives.length === 0) return null;

    const count = reputation.reviewCount;

    const parts = negatives
        .map((n) => n.trim().replace(/[.!?\s]+$/u, ""))
        .filter((n) => n.length > 0)
        .map((n, i) => (i === 0 ? n : n.charAt(0).toLowerCase() + n.slice(1)));
    const finePrint =
        parts.length === 0 ? "" : `${FINE_PRINT_LIST.format(parts)}.`;

    return (
        <section className="lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start lg:gap-x-16">
            <div>
                <h2 className="text-section-title text-doberman-black text-balance">
                    {storiesBelow
                        ? "What families say"
                        : count != null
                          ? `The gist of ${count} reviews`
                          : "What people consistently say"}
                </h2>
                <p className="mt-3 text-body-small text-doberman-black/50">
                    Summarized from their public reviews.
                </p>
            </div>

            <div className="mt-5 lg:mt-0 lg:max-w-190">
                {positives.length > 0 && (
                    <div className="flex flex-wrap gap-3">
                        {positives.map((positive) => (
                            <div
                                key={positive}
                                className="flex max-w-full items-start gap-2.5 rounded-nested bg-havanese px-4 py-3"
                            >
                                <span
                                    aria-hidden="true"
                                    className="mt-px select-none font-family-heading text-xl leading-none text-secondary-copper/70"
                                >
                                    “
                                </span>
                                <span className="text-body text-doberman-black/85">
                                    {positive}
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                {finePrint && (
                    <div className="mt-5 border-t border-doberman-black/10 pt-4">
                        <p className="text-body font-semibold text-doberman-black">
                            Before you fall in love
                        </p>
                        <p className="mt-1.5 text-body text-doberman-black/70">
                            {finePrint}
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}
